import { useEffect, useState } from "react";
import NavBar from "../../../components/navbar/NavBar";
import SolanaGraph from "../../../components/websocket/SolanaGraph";
import SolanaPrice from "../../../components/websocket/SolanaPrice";
import loyalsImage from "../../../assets/images/lf-dashboard.jpg";
import { useSelector } from "react-redux";
import axios from "axios";
import messages from "../../../constants/messages";
import Swal from "sweetalert2";
import useGetLALBalance from "../../../utils/hooks/GetLALBalance";
import useGetTokenQuantity from "../../../utils/hooks/getGoesOutToken";
import Spinner from "react-bootstrap/Spinner";

const AdminDashboard = () => {
  const [treasuryBalance, devBalance, contractBalance] = useGetLALBalance();
  const { currentSlot, loadingState, getGoesOutToken, totalBuyable } =
    useGetTokenQuantity();
  const [isOpen, setIsOpen] = useState(false);
  const [userCount, setUserCount] = useState(0);
  const [requests, setRequests] = useState(0);
  const [heading, setHeading] = useState("Available Tokens");
  const [displayValue, setDisplayValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state) => state.userStore.user);
  const token = user.auth;

  const tokenPrice = process.env.REACT_APP_TOKEN_PRICE;

  const fetchData = async () => {
    try {
      const userCountResponse = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/users/totalUserCount`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUserCount(userCountResponse?.data?.totalUser);

      const requestsResponse = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/users/CountPendingChangeWalletRequest`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setRequests(requestsResponse?.data?.totalPendingChangeWalletRequest);
    } catch (error) {
      Swal.fire({
        title: messages.titles.error,
        text: messages.errors.somethingWentWrong,
        icon: "error",
        confirmButtonText: messages.buttons.ok,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, [token]);

  useEffect(() => {
    const fetchTokenData = async () => {
      setIsLoading(true);
      await getGoesOutToken();
      setIsLoading(false);
    };
    if (!loadingState && totalBuyable) {
      fetchTokenData();
    }
  }, [loadingState, totalBuyable]);

  useEffect(() => {
    if (isLoading || loadingState) {
      setHeading("Available Tokens");
      setDisplayValue(0);
    } else {
      if (currentSlot === null) {
        setHeading("Available Tokens");
        setDisplayValue(0);
      } else if (currentSlot === 0) {
        setHeading("Available Tokens in Slot 1");
        setDisplayValue(totalBuyable);
      } else if (currentSlot >= 1 && currentSlot <= 12) {
        setHeading(`Available Tokens in Slot ${currentSlot + 1}`);
        setDisplayValue(totalBuyable);
      } else if (currentSlot === 13) {
        setHeading("Available Tokens");
        setDisplayValue(contractBalance);
      }
    }
  }, [isLoading, loadingState, currentSlot, totalBuyable, contractBalance]);

  return (
    <>
      <NavBar />
      <div className={`sidebar-sec ${isOpen ? "active" : ""}`}>
        <section id="content-wrapper admin-dashboard-pannel">
          <h4 className="my-dash admin-dashboard-pannel">My Dashboard</h4>
          <div className="container-fluid admin-dashboard-pannel">
            <div className="dashboard-card-sec">
              <div className="row align-items-stretch solana-display">
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-six">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        {heading}
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count">
                        <p className="display-balance">
                          {isLoading ? (
                            <Spinner
                              animation="border"
                              variant="dark"
                              size="sm"
                            />
                          ) : (
                            displayValue
                          )}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-six">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        Total Tokens on Contract
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count">
                        <p className="display-balance">{contractBalance}</p>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-five">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        User Count
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count">
                        <p className="display-balance">{userCount}</p>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-six">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        Change Wallet Requests
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count">
                        <p className="display-balance">{requests}</p>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-one">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        Current Solana Price
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count solana-user">
                        <SolanaPrice />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-two">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        Current $LAL Price
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count">
                        <p className="display-balance">${tokenPrice} USD</p>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-three">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        Treasury Wallet $LAL Balance
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count">
                        <p className="display-balance">
                          {treasuryBalance} $LAL
                        </p>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="c-dashboardInfo">
                    <div className="wrap card-four">
                      <h4 className="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                        Dev Wallet $LAL Balance
                      </h4>
                      <span className="hind-font caption-12 c-dashboardInfo__count">
                        <p className="display-balance">{devBalance} $LAL</p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className=" col-lg-6 col-md-6 col-sm-12">
                  <div className="lf-dashboard">
                    <img src={loyalsImage} alt="Logo" />
                  </div>
                </div>
                <div className=" col-lg-6 col-md-6 col-sm-12">
                  <SolanaGraph />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminDashboard;
